<template>
	<section class="container">
		<div class="lay">
			<div class="row">
				<left-menu></left-menu>
				<div class="row-item row-item_content">
					<article>
						<ul class="submenu">
							<li class="submenu-item">
								<nuxt-link class="submenu-itemLink" href="/services" to="/services">
									Расписание групповых занятий
								</nuxt-link>
							</li>
						</ul>
						<schedule
							v-model="schedule"
							type="0"
							:count="schedule.count"
							:sessions="$store.state.schedule.sessions"
						></schedule>
					</article>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import helper from '@/plugins/helper.js';
import schedule from '@/components/schedule.vue';
import leftMenu from '@/components/leftmenu.vue';

//Мероприятия - список сеансов услуг, на которые можно записаться
let defaults = {
	date: new Date(),
	count: 9,
};
export default {
	components: {
		schedule,
		leftMenu,
	},
	data() {
		return {
			schedule: defaults,
		};
	},
	watch: {
		async schedule() {
			this.$store.commit('api/addQuery', {
				task: 'getSessions',
				data: {
					date: helper.dateFormat(this.schedule.date),
					count: this.schedule.count,
					type: '0',
				},
			});
			return await this.$store.dispatch('init', { route: this.$route });
			//return this.fetch({store: this.$store, route: this.$route});
		},
	},
	created() {
		this.$store.commit('api/addQuery', {
			task: 'getSessions',
			data: {
				date: helper.dateFormat(this.schedule.date),
				count: this.schedule.count,
				type: '0',
			},
		});
	},
	mounted() {
		//console.log(api);
	},
};
</script>
